import { combineReducers } from 'redux';

import * as types from 'constants/ActionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  hasError: boolean,
 *  data: Array<{ hasRatingComment: number, hasFollowUpSent: number, sent: number }>,
 *  loading: boolean,
 * }} StatisticsFollowUpReducer
 */

export default combineReducers({
  hasError: createReducer(false, {
    [types.FETCH_STATISTICS_INTERVENTION_FOLLOW_UP_STATS_REQUEST]: () => false,
    [types.FETCH_STATISTICS_INTERVENTION_FOLLOW_UP_STATS_SUCCESS]: () => false,
    [types.FETCH_STATISTICS_INTERVENTION_FOLLOW_UP_STATS_FAILURE]: () => true,
  }),
  data: createReducer([], {
    [LOCATION_CHANGE]: () => [],
    [types.FETCH_STATISTICS_INTERVENTION_FOLLOW_UP_STATS_SUCCESS]: (_, { payload }) => payload.content?.[0],
  }),
  loading: createReducer(false, {
    [types.FETCH_STATISTICS_INTERVENTION_FOLLOW_UP_STATS_REQUEST]: () => true,
    [types.FETCH_STATISTICS_INTERVENTION_FOLLOW_UP_STATS_SUCCESS]: () => false,
    [types.FETCH_STATISTICS_INTERVENTION_FOLLOW_UP_STATS_FAILURE]: () => false,
  })
});
